(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["polygons-reviews"] && !Shopify.designMode) return;
  try {
    (() => {
    const bootReviews = (event) => {
      const widget = document.getElementById('stamped-main-widget');
      if (!widget) return;

      const syncReviewSummary = () => {
        const summary = widget.querySelector('.stamped-summary-text-1[data-count][data-rating], .stamped-summary-text[data-count][data-rating]');
        if (!summary) return;
        const countText = summary.getAttribute('data-count'), rating = Number(summary.getAttribute('data-rating'));
        if (!/^\d+$/.test(countText || '') || !Number.isSafeInteger(Number(countText)) || !Number.isFinite(rating) || rating <= 0 || rating > 5) return;
        const count = String(Number(countText)), ratingText = rating.toFixed(1);
        document.querySelectorAll('[data-polygons-review-rating]').forEach(node => { node.textContent = ratingText; });
        document.querySelectorAll('[data-polygons-review-count]').forEach(node => {
          node.textContent = node.dataset.countLabel ? node.dataset.countLabel.replace('__count__', count) : count;
        });
        document.querySelectorAll('[data-polygons-review-stars]').forEach(node => {
          node.style.setProperty('--pct', `${rating * 20}%`);
          if (node.dataset.ratingLabel) node.setAttribute('aria-label', node.dataset.ratingLabel.replace('__rating__', ratingText));
        });
      };
      syncReviewSummary();
      if (!widget.dataset.polygonsSummaryBound && typeof MutationObserver !== 'undefined') {
        widget.dataset.polygonsSummaryBound = 'true';
        new MutationObserver(syncReviewSummary).observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-count', 'data-rating'] });
      }

      const writeLink = document.querySelector('[data-polygons-write-review]');
      if (writeLink && !writeLink.dataset.bound) {
        writeLink.dataset.bound = 'true';
        writeLink.addEventListener('click', (event) => {
          const nativeAction = widget.querySelector('.stamped-summary-actions-newreview');
          if (!window.isInitializedStamped || !nativeAction) return;
          event.preventDefault();
          nativeAction.click();
          widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      if (window.StampedFn) {
        if (event && event.type === 'shopify:section:load' && window.StampedGlobalOptions) {
          window.StampedFn.init(window.StampedGlobalOptions);
        }
        return;
      }
      if (window.polygonsStampedLoading) return;
      const existingScript = Array.from(document.scripts).find((script) => {
        if (!script.src) return false;
        try {
          const url = new URL(script.src, document.baseURI);
          return /(^|\.)(stamped\.io|cdn-stamped-io\.azureedge\.net)$/.test(url.hostname)
            && url.pathname.endsWith('/widget.min.js');
        } catch {
          return false;
        }
      });
      if (existingScript) return;

      window.polygonsStampedLoading = true;
      const script = document.createElement('script');
      script.id = 'stamped-script-widget';
      script.src = 'https://cdn1.stamped.io/files/widget.min.js';
      script.async = true;
      script.addEventListener('error', () => {
        window.polygonsStampedLoading = false;
      });
      document.head.appendChild(script);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootReviews, { once: true });
    } else {
      bootReviews();
    }
    document.addEventListener('shopify:section:load', bootReviews);
  })();
  } catch(e) { console.error(e); }
})();

})();
